/** PO 2026-10-07: omit empty reasons from requests. */
export const MAX_NOTE = 500;
export const MAX_DISCARD_REASON = 1000;

export function reasonFields(value: unknown, field: 'reason' | 'note' = 'reason', limit = field === 'note' ? MAX_NOTE : MAX_DISCARD_REASON): Record<string, string> {
  const reason = typeof value === 'string' ? value.trim().slice(0, limit) : '';
  return reason ? { [field]: reason } : {};
}
